import { BaseResource } from '../core/base-resource';

export class ReOrder extends BaseResource {
  orderId?: string;
  force?: boolean;
  isMobileSource?: boolean;
}
